import React, { useState } from "react";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import { Avatar } from "@fluentui/react-components";
import "./actionable-members-dropdown.scss";

const popperConfig = {
  placement: "bottom-end",
  strategy: "fixed",
};

const position = [
  "actionable-members-first-icon",
  "actionable-members-second-icon",
  "actionable-members-third-icon",
  "actionable-members-fourth-icon",
];

/**
 * Simplified member dropdown component for displaying actionable members.
 * Shows stacked avatars with a dropdown list of all members.
 * No groups logic - members only.
 */
const ActionableMembersDropdown = ({ members }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  if (!members || members.length === 0) {
    return <span></span>;
  }

  const FindClassName = (length) => {
    if (length <= 3) {
      return "actionable-member-panel";
    } else if (length <= 5) {
      return "actionable-member-panel-medium";
    } else {
      return "actionable-member-panel-large";
    }
  };

  return (
    <div className="actionable-members-dropdown">
      <Dropdown
        drop="down"
        className="removeArrow"
        onMouseLeave={() => setShowDropdown(false)}
        onMouseOver={() => setShowDropdown(true)}
        onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
      >
        <Dropdown.Toggle
          as="div"
          className="actionable-members-toggle"
          onClick={(e) => e.nativeEvent.stopImmediatePropagation()}
        >
          {members.slice(0, 4).map((member, index) => (
            <div key={member.Id || index} className={position[index]}>
              {index === 3 && members.length > 4 ? (
                <Avatar
                  initials={`+${members.length - 3}`}
                  className="actionable-avatar actionable-avatar-extra actionable-avatar-toggle"
                  color="white"
                />
              ) : (
                <Avatar
                  name={member.Name}
                  color="blue"
                  className="actionable-avatar actionable-avatar-toggle"
                />
              )}
            </div>
          ))}
        </Dropdown.Toggle>
        <Dropdown.Menu
          popperConfig={popperConfig}
          show={showDropdown}
          style={{ width: "280px" }}
          className={FindClassName(members.length)}
        >
          <div className="actionable-dropdown-header">
            <div className="actionable-dropdown-title">Actionable by</div>
          </div>
          <Dropdown.Divider style={{ width: "280px" }} />
          <div className="actionable-dropdown-body">
            {members.map((member, index) => (
              <div key={member.Id || index} className="actionable-member-row">
                <Avatar
                  size={24}
                  name={member.Name}
                  color="blue"
                  className="actionable-member-avatar"
                />
                <div className="actionable-member-info">
                  <span className="actionable-member-name">{member.Name}</span>
                  {member.RoleName && (
                    <span className="actionable-member-role">{member.RoleName}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

ActionableMembersDropdown.propTypes = {
  members: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.number,
      Name: PropTypes.string,
      RoleName: PropTypes.string,
    })
  ).isRequired,
};

export default ActionableMembersDropdown;

